import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { useLang } from '~/stores/i18n';

const HostStatusRedirect = () => {
  const lang = useLang();
  return <Redirect to={generatePathnameWithLangCode(`/host/status/`, lang)} />;
};

const routes = (
  <Route path={`${basePath}/host/manage-status`}>
    <HostStatusRedirect />
  </Route>
);

export default routes;
